import script from "./Tabulator.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabulator.vue?vue&type=script&setup=true&lang=js"

import "./Tabulator.vue?vue&type=style&index=0&id=b490709a&lang=scss"

const __exports__ = script;

export default __exports__